import React from 'react';

import './style.scss';

function Loader() {
  return (
    <div className="loader-container">
      <i className="fas fa-spinner fa-spin fa-3x" />
    </div>
  );
}

export default Loader;
